const getLocalization = <T extends Record<string, string>>(
  localization: T,
  key: keyof T
): string | keyof T => {
  return localization?.[key] || key;
};

export default getLocalization;
